import React from "react";
import * as Icon from "react-bootstrap-icons";
import * as Utils from "../../inc/Utils";
import {Link, NavLink} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import {Config} from '../../Config'
import * as XLSX from 'sheetjs-style';


export default function UtmExport() {
    const roles = new Role();

    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');

    React.useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setLoading(true);
        fetch(Config.url.API_URL +'/api/utm/listingExport', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
            })
        }).then(response => {
            setLoading(false);
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            setData(result);
        }).catch(err => {
            toast.error(err.message);
        });
    };

    const downloadExcel = (data, countCols, countRows) => {
        let char1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');

        // Acquire Data (reference to the HTML table)
        var table_elt = document.getElementById("table-export");

        // Extract Data (create a workbook object from the table)
        let workbook = XLSX.utils.table_to_book(table_elt);

        let ws = workbook.Sheets["Sheet1"];

        let i=1;
        let start=0;
        let hCount=0;
        for(let row of data) {
            hCount = row.items.length;
            let alp = char1[i===1 ? 0:start];
            start += hCount;
            ws[alp+"1"].s = {
                font: {
                    bold: true,
                    color: {
                        rgb: "00000000"
                    }
                },
                alignment: {
                    vertical: "center",
                    horizontal: "center"
                }
            };
            i++;
        }

        for(let c=0;c<countCols;c++) {
            let alp = char1[c];
            for(let r=3;r<countRows+3;r++) {
                ws[alp+r].s = {
                    alignment: {
                        vertical: "center",
                        horizontal: "center"
                    }
                };
            }
        }

        XLSX.utils.sheet_add_aoa(ws, [["Created "+new Date().toISOString()]], {origin:-1});
        XLSX.writeFile(workbook, "UTMDataSheet_" + Utils.getDate() + ".xlsx");
    };

    let typeRowCount = 0;
    let typeRows = [];
    let countSourceCol = 0;
    let arr = [];
    let newSourceItem = [];
    if(data) {
        for(let row of data) {
            countSourceCol += row.items.length;
            for(let rs of row.items) {
                arr.push(rs.sourceItems ? rs.sourceItems.length:0);
            }
        }
        typeRowCount = Math.max(...arr);

        //STEP 1
        let i=0;
        for(let row of data) {
            for(let rs of row.items) {
                newSourceItem.push(rs.sourceItems);
                i++;
            }
        }
        //STEP 2
        //==> Left to Right
        for(let m=0;m<typeRowCount;m++) {
            typeRows.push({id:m});
        }
    }

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Export UTM</div>
                    <span className="ms-1">/</span> <span className="text-muted">Preview</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    <NavLink className="btn btn-sm btn-light me-2" to='/utm'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                </div>
            </div>
            {isLoading ? (<span className="spinner-grow spinner-grow-sm"></span>) :
            <>
                {data.length <= 0 ? (<p>ไม่พบข้อมูล</p>) :
                    <>
                        <div className="table-responsive">
                            <table className="table table-bordered" id="table-export">
                                <tbody>
                                    <tr>
                                    {
                                        data.map((row, index) => (
                                            <React.Fragment>
                                                <td key={index} className="text-center bg-danger text-white" align="center" colSpan={row.items.length}>{row.name}</td>
                                            </React.Fragment>
                                        ))
                                    }
                                    </tr>
                                    <tr>
                                    {
                                        data.map((row, a) => (
                                            row.items.map((item, b) => (
                                                <React.Fragment>
                                                    <td key={a+b} className="text-center">{item.name}</td>
                                                </React.Fragment>
                                            ))
                                        ))
                                    }
                                    </tr>
                                    {
                                    typeRows.map((tp) => (
                                    <tr>
                                        {
                                            newSourceItem.map((it, a) => (
                                                <React.Fragment>
                                                    <td className="text-center">{it[tp.id] ? it[tp.id].name : ' '}</td>
                                                </React.Fragment>
                                            ))
                                        }
                                    </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        <div className="row mt-3 justify-content-center">
                            <div className="col-12 text-center">
                                {roles.isView(Utils.MENU_UTM) ? (
                                    <button className="btn btn-sm btn-success px-3" onClick={()=>downloadExcel(data, countSourceCol, typeRowCount)}><span><Icon.Download/> Download Excel</span></button>
                                ) : ''}
                            </div>
                        </div>
                    </>
                }
            </>
            }
        </main>
    );
} 